// extracted by mini-css-extract-plugin
module.exports = {"lfo":"lfo_lfo__1Wa1I"};